import { createTheme, responsiveFontSizes } from '@mui/material/styles'
import overrides from './overrides'
import palette from './palette'
import typography from './typography'
import shape from './shape'

let theme = createTheme({
  palette,
  typography,
  shape,
})

theme = responsiveFontSizes(theme)

theme.components = overrides(theme) as typeof theme.components

export default theme
